module.exports = __webpack_public_path__ + "img/Shadow-Moses.1fe5e5a1.png";